import RentlerMap from './map'
import SearchDetailMap from './search-detail-map'
import Modal from './modal'
import Filters from './filters'
import Gallery from './gallery'
import SearchDetail from './search-detail'
import CampaignBanner from './campaign-banner'
import $ from 'domtastic'
import axios from 'axios'
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/bgset/ls.bgset'
import './smartbanner'
import { getAuthUrl, isAuthenticated } from './auth'
import { setLeadAttributions } from './lead-attributions'
import { deletePreference, loadFilterFromPreference } from './preferences'
import { trackGtmTenantFavoriteListing } from './analytics'

document.addEventListener('DOMContentLoaded', function (event) {
  setLeadAttributions()

  new CampaignBanner()

  let map

  if (document.getElementById('map')) {
    map = new RentlerMap('map')
    window.MapUtilty = map
  }

  if (document.getElementById('search-detail-map')) {
    new SearchDetailMap()
  }

  $('.custom-form-item input').on('blur', function () {
    let val = $(this)[0].value

    if (val.length > 0) {
      $(this).parent().find('.custom-placeholder').addClass('static')
      $(this).parent().removeClass('fill')
    } else {
      $(this).parent().find('.custom-placeholder').removeClass('static')
      $(this).parent().addClass('empty')
    }
  })

  $('.custom-form-item textarea').on('blur', function () {
    let val = $(this)[0].value

    if (val.length > 0) {
      $(this).parent().find('.custom-placeholder').addClass('static')
    } else {
      $(this).parent().find('.custom-placeholder').removeClass('static')
    }
  })

  if (document.querySelector('.search-list-items')) {
    $('body').on(
      'click',
      '.saved-search-item .btn-delete-preference',
      function (e) {
        e.preventDefault()
        const tenantPreferenceId = $(this)
          .closest('[data-preference-id]')
          .attr('data-preference-id')
        deletePreference(tenantPreferenceId)
      }
    )

    $('body').on('click', '.saved-search-item .btn-view-results', function (e) {
      e.preventDefault()
      const tenantPreferenceId = $(this)
        .closest('[data-preference-id]')
        .attr('data-preference-id')
      loadFilterFromPreference(tenantPreferenceId)
    })

    $('body').on('click', '.listing-item .btn-favorite', function (e) {
      e.preventDefault()

      if (!isAuthenticated()) {
        window.location.href = getAuthUrl()
        return
      }

      const listingId = +$(this).parent().attr('data-id')
      const liked = $(this).parent().attr('data-liked') == 'true'
      const favorites = $('[data-favorites]').attr('data-favorites').split(',')
      const favoritesApi = `${rentler.apiBaseUri}/favorites`

      if (liked) {
        axios.delete(`${favoritesApi}/${listingId}`).then(() => {
          $(this).parent().attr('data-liked', false)
          $(this).parent().removeClass('liked')
          $('[data-favorites]').attr(
            'data-favorites',
            favorites.filter((x) => x !== `${listingId}`).join(',')
          )
          $(`.listing-item[data-id='${listingId}']`)
            .removeClass('liked')
            .attr('data-liked', false)
          if (window.MapUtilty) {
            let dataCopy = [
              ...window.MapUtilty.rentlerMap.getSource('rents')._data.features,
            ]
            const feature = dataCopy.find(
              (f) =>
                f.properties.id === listingId ||
                (f.properties.ids &&
                  f.properties.ids.split(',').includes(listingId.toString()))
            )
            feature.properties.liked = false
            window.MapUtilty.updateMapMarkers({
              features: dataCopy,
              type: 'FeatureCollection',
            })
          }
        })
      } else {
        axios.post(`${favoritesApi}`, { listingId }).then(() => {
          $(this).parent().attr('data-liked', true)
          $(this).parent().addClass('liked')
          $('[data-favorites]').attr(
            'data-favorites',
            favorites.join(',') + `,${listingId}`
          )
          $(`.listing-item[data-id='${listingId}']`)
            .addClass('liked')
            .attr('data-liked', true)
          if (window.MapUtilty) {
            let dataCopy = [
              ...window.MapUtilty.rentlerMap.getSource('rents')._data.features,
            ]
            const feature = dataCopy.find(
              (f) =>
                f.properties.id === listingId ||
                (f.properties.ids &&
                  f.properties.ids.split(',').includes(listingId.toString()))
            )
            feature.properties.liked = true
            window.MapUtilty.updateMapMarkers({
              features: dataCopy,
              type: 'FeatureCollection',
            })
          }
          trackGtmTenantFavoriteListing({ listingId })
        })
      }
    })
  }

  $('.range-select').on('mouseleave', function (e) {
    $('.range-select .ghost-radio-wrapper').removeClass('fake-range-selected')
    $('.range-select .ghost-radio-wrapper').removeClass('fake-active')
    $('.range-select .ghost-radio-wrapper').removeClass('fake-start')
    $('.range-select .ghost-radio-wrapper').removeClass('full-active')
  })

  window.$ = $

  $('.range-select .ghost-radio-wrapper').on('mouseover', function () {
    $('.range-select .ghost-radio-wrapper').removeClass('fake-range-selected')
    $('.range-select .ghost-radio-wrapper').removeClass('fake-active')
    $('.range-select .ghost-radio-wrapper').removeClass('fake-start')
    $('.range-select .ghost-radio-wrapper').removeClass('full-active')
    let areClassesAdded = false
    let isStartFound = false
    let isStartNextEl = false
    let nodeResults = []
    let isAnyChildHasStartClass = $(this)
      .parent()
      .children()
      .filter((el) => $(el).hasClass('start')).length
    let isAnyChildHasActiveClass = $(this)
      .parent()
      .children()
      .filter((el) => $(el).hasClass('active')).length

    // if (isAnyChildHasActiveClass && isAnyChildHasStartClass) {
    //   return
    // }

    if (isAnyChildHasStartClass) {
      let node = $(this)[0]

      while (node) {
        if (node !== this && node.nodeType === Node.ELEMENT_NODE)
          nodeResults.push(node)
        node = node.nextElementSibling || node.nextSibling
      }

      nodeResults.map((nodeEl) => {
        if ($(nodeEl).hasClass('start')) {
          isStartNextEl = true
        }
      })

      if (isStartNextEl) {
        // console.log('nodeResults', nodeResults)
        $(this).addClass('fake-start')
      }

      // console.log('isStartNextEl', isStartNextEl)
    }

    $(this)
      .parent()
      .children()
      .map((el) => {
        if (!areClassesAdded) {
          // Hide real active while select
          if (el != $(this)[0]) {
            if ($(el).hasClass('start')) {
              $(el).addClass('fake-range-selected')
              isStartFound = true
              return
            }

            if (isStartFound) {
              $(el).addClass('fake-range-selected')
              return
            }
          } else {
            $(el).addClass('fake-range-selected')
            $(el).addClass('fake-active')

            if (!isAnyChildHasStartClass) {
              $(el).addClass('fake-start')
            }

            if (isStartNextEl) {
              let areClassesAddedUntilActive = false
              let areClassesAddedUntilStart = false
              $(el).removeClass('fake-active')

              nodeResults.map((elem) => {
                if (isAnyChildHasActiveClass) {
                  if (!areClassesAddedUntilActive) {
                    if ($(elem).hasClass('start')) {
                      $(elem).addClass('full-active')
                    }

                    if ($(elem).hasClass('active')) {
                      // $(elem).removeClass('fake-range-selected')
                      areClassesAddedUntilActive = true
                    } else {
                      $(elem).addClass('fake-range-selected')
                    }
                  }
                } else {
                  if (!areClassesAddedUntilStart) {
                    // if ($(elem).hasClass('start')) {
                    //   $(elem).addClass('full-active')
                    // }

                    if ($(elem).hasClass('start')) {
                      $(elem).addClass('fake-active')
                      $(elem).addClass('full-active')
                      $(elem).addClass('fake-range-selected')
                      areClassesAddedUntilStart = true
                    } else {
                      $(elem).addClass('fake-range-selected')
                    }
                  }
                }
              })
            }

            areClassesAdded = true
          }
        }
      })
  })

  if (document.querySelector('.mobile-change-view-button')) {
    $('.mobile-change-view-button').on('click', () => {
      if ($('.mobile-change-view-button').hasClass('list-view')) {
        $('.mobile-change-view-button .text').text('Map View')
        $('.mobile-change-view-button .icon').html(
          '<span class="icon-map-icon"></span>'
        )
        $('.module.map').removeClass('open')
        $('.main-wrapper.listing').removeClass('list-style-opened')
        $('.module.search-listing').removeClass('d-none')
        $('.mobile-change-view-button').removeClass('list-view')
      } else {
        $('.mobile-change-view-button .text').text('List View')
        $('.mobile-change-view-button .icon').html(
          '<span class="icon-list-icon"></span>'
        )
        $('.module.map').addClass('open')
        $('.main-wrapper.listing').addClass('list-style-opened')
        $('.module.search-listing').addClass('d-none')
        $('.mobile-change-view-button').addClass('list-view')
      }
    })
  }

  // lazysizes
  window.lazySizesConfig = window.lazySizesConfig || {}
  // window.lazySizesConfig.customMedia = {
  //   '--small': '(max-width: 480px)',
  //   '--medium': '(max-width: 700px)',
  // }

  // init modals
  if (document.body.classList.contains('is-search-detail-page')) {
    new Modal()
    new Gallery()
    new SearchDetail()
  }

  if ($('.filters-wrapper')) {
    var mouseupListener

    $('.fake-selectbox').on('click', function (el) {
      $(this).siblings('.selector-modal').addClass('open')
      $(this).children('.text').addClass('colored')

      document.querySelector(`.filter-overlay`).classList.add('open')

      document
        .querySelector(`.filter-overlay`)
        .classList.add($(this).attr('id'))

      mouseupListener = (e) => {
        let container = $(this).siblings('.selector-modal')

        if (
          (container[0] !== e.target &&
            container.find('*').filter((c) => c == e.target).length === 0) ||
          $(e.target).hasClass('icon-Shape-9') ||
          $(e.target).hasClass('close-icon')
        ) {
          if ($(`.filter-overlay.${$(this).attr('id')}`)[0]) {
            $(`.filter-overlay.${$(this).attr('id')}`)[0].classList.remove(
              'open'
            )

            $(`.filter-overlay.${$(this).attr('id')}`)[0].classList.remove(
              $(this).attr('id')
            )
          }

          container.removeClass('open')

          $('.text').removeClass('colored')
        }

        mouseupListener = null

        document
          .querySelector('html')
          .removeEventListener('mouseup', mouseupListener)
      }

      document
        .querySelector('html')
        .addEventListener('mouseup', mouseupListener)
    })
  }

  // esc clicked
  const clickEvent = new Event('back-to-default')
  document.onkeydown = function (evt) {
    evt = evt || window.event
    var isEscape = false
    if ('key' in evt) {
      isEscape = evt.key === 'Escape' || evt.key === 'Esc'
    } else {
      isEscape = evt.keyCode === 27
    }
    if (isEscape) {
      window.dispatchEvent(clickEvent)
    }
  }

  // burger
  var $burger = document.querySelector('.burger')
  $burger.addEventListener('click', function (event) {
    event.preventDefault()
    document.body.classList.toggle('is-header-open')
    return false
  })

  // mobile nav
  var $firstLevelNav = document.querySelectorAll('header nav > ul > li a')
  for (const links of $firstLevelNav) {
    links.addEventListener('click', function (event) {
      var parent = event.target.parentNode
      parent.classList.toggle('is-open')
    })
  }

  // Initialize filters
  if (document.querySelector('.filters-wrapper')) {
    window.FilterUtility = new Filters()
  }
})
